export default "__VITE_ASSET__kO6gaRug__"